import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-sm" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InAppLink = _resolveComponent("InAppLink")!
  const _component_Form = _resolveComponent("Form")!
  const _component_AuthLayout = _resolveComponent("AuthLayout")!

  return (_openBlock(), _createBlock(_component_AuthLayout, {
    title: _ctx.$t('We hope to see you again') + ' ⭐',
    imgHideMobile: true
  }, {
    default: _withCtx(() => [
      _createVNode(_component_Form, {
        onSuccess: _ctx.authUser,
        formApi: "/register",
        btnTitle: _ctx.$t('Sign up'),
        hasSlotBeforeSubmitButton: true,
        fields: _ctx.fields
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createTextVNode(_toDisplayString(_ctx.$t('By signing up you agree to our')) + " ", 1),
            _createVNode(_component_InAppLink, { to: "/terms" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('Terms & conditions')), 1)
              ]),
              _: 1
            }),
            _createTextVNode(" " + _toDisplayString(_ctx.$t('and')) + " ", 1),
            _createVNode(_component_InAppLink, { to: "/privacy" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('Privacy Policy')), 1)
              ]),
              _: 1
            }),
            _createTextVNode(". ")
          ])
        ]),
        _: 1
      }, 8, ["onSuccess", "btnTitle", "fields"])
    ]),
    _: 1
  }, 8, ["title"]))
}